import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c655ae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publish-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "publish-description" }, "Veröffentliche eine neue Version deines Chatbots und stelle so den aktuellen Stand für alle Benutzer bereit.", -1))
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Abbrechen")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Version veröffentlichen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_md_input_field, {
      modelValue: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
      label: "Name",
      variant: "filled"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_md_input_field, {
      modelValue: _ctx.description,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
      label: "Beschreibung (optional)",
      variant: "filled",
      error: false
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_md_button, {
        variant: "filled",
        disabled: !_ctx.name || _ctx.name.length <= 0,
        onClick: _ctx.publishVersion
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}